import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { Collateral } from '../types/collateral.types';

/**
 * Pure UI state for the collateral management views. Server state lives in
 * react-query, not here.
 */
interface CollateralState {
    formModalOpen: boolean;
    editing: Collateral | null;
    documentModalOpenForId: number | null;

    openCreateForm: () => void;
    openEditForm: (collateral: Collateral) => void;
    closeForm: () => void;
    openDocumentModal: (collateralId: number) => void;
    closeDocumentModal: () => void;
    reset: () => void;
}

export const useCollateralStore = create<CollateralState>()(
    devtools(
        (set) => ({
            formModalOpen: false,
            editing: null,
            documentModalOpenForId: null,

            openCreateForm: () => set({ formModalOpen: true, editing: null }),
            openEditForm: (collateral) =>
                set({ formModalOpen: true, editing: collateral }),
            closeForm: () => set({ formModalOpen: false, editing: null }),
            openDocumentModal: (collateralId) =>
                set({ documentModalOpenForId: collateralId }),
            closeDocumentModal: () => set({ documentModalOpenForId: null }),
            reset: () =>
                set({
                    formModalOpen: false,
                    editing: null,
                    documentModalOpenForId: null,
                }),
        }),
        { name: 'collateral-management' },
    ),
);
